import { FacilityTypes } from '../models';

export function isEither(type: FacilityTypes | undefined): boolean {
	return isRevolverFacilityType(type) || isTermLoan(type);
}

export function isRevolverFacilityType(type: FacilityTypes | undefined): boolean {
	return type != undefined && (type == 'Revolver' || type == 'Line_of_Credit');
}

export function isLeaseFacilityType(type: FacilityTypes | undefined): boolean {
	return type != undefined && (type == 'CapitalLease' || type == 'EquipmentLease' || type == 'OperatingLease');
}

export function isTermLoan(type: FacilityTypes | undefined): boolean {
	return type != undefined && !isRevolverFacilityType(type) && !isLeaseFacilityType(type);
}

export function isFactorPO(type: FacilityTypes | undefined): boolean {
	return type == 'PurchaseOrderFinancing' || type == 'Factor';
}
